import axios from "axios";
import cheerio from "cheerio";
import Constants from "../helper/Constants";

const isWebsiteSquarespace = ($) => {
  const comments = $("*")
    .contents()
    .filter((_, elem) => elem.nodeType === 8)
    .filter((_, elem) => elem.data.includes("Squarespace"));

  return comments.length > 0;
};

const getJSON = (scriptTag) => {
  const { data } = scriptTag["0"].children["0"];
  const jsonExpression = data.split("Static = window.Static || {};")[1];

  const jsonBracketIndex = jsonExpression.indexOf("{");
  const json = jsonExpression.substring(jsonBracketIndex);
  const endingBrace = json.lastIndexOf(";");
  const finalJson = json.substring(0, endingBrace);

  return JSON.parse(finalJson);
};

const findTemplateID = ($) => {
  const scriptTag = $("script").filter((_, elem) => elem.attribs["data-name"]);

  if (!scriptTag) {
    return;
  }

  const templateID = getJSON(scriptTag).templateId;
  return templateID;
};

const templateIds = {
  "54d3906fe4b04c1c9981b00e": "SKYE",
  "55f0aac0e4b0f0a5b7e0b22e": "BRINE",
  "5630efcfe4b076f55fe4837f": "FARRO",
  "56d9c12107eaa07660adbcad": "TREMONT",
  "55dccafee4b04b8e0d7b6d4d": "YORK"
};

const AjaxCheck = (url) => {
  return new Promise((resolve, reject) => {
    const corsURL = `${process.env.CORS_PROXY_URL}${url}`;
    console.log(corsURL);
    axios
      .get(corsURL)
      .then((res) => {
        const { data } = res;
        const $ = cheerio.load(data);
        const errorObj = {
          mainTitle: Constants.Ajax.MainErrorMessage.AJAX_LOADING_FOUND
        };

        if (isWebsiteSquarespace($)) {
          const templateID = findTemplateID($);

          if (!templateID) {
            errorObj.subTitle =
              Constants.Ajax.SecondaryErrorMessage.THEME_NOT_FOUND;
            reject(errorObj);
          }

          if (templateID in templateIds) {
            errorObj.subTitle =
              Constants.Ajax.SecondaryErrorMessage[templateIds[templateID]];
            reject(errorObj);
          }

          resolve(Constants.Ajax.SuccessMessage.VALID_THEME);
        }

        resolve(Constants.Ajax.SuccessMessage.VALID_THEME);
        // Below is for testing
        // errorObj.subTitle = "Bad Theme";
        // reject(errorObj);
      })
      .catch((err) => console.log(err));
  });
};

export default AjaxCheck;
